import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("link", {
  id: "bootstrap",
  href: "/css/custom.css",
  rel: "stylesheet"
}, null, -1)
const _hoisted_2 = { id: "login" }
const _hoisted_3 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-xxl-6 col-xl-7 col-lg-8 col-md-10 mx-auto" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", { class: "display-3 mb-3 text-center" }, "Área de clientes", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "fw-medium mb-2" }, "Inicia sesión", -1)
const _hoisted_10 = { class: "form-floating mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "NIF/CIF", -1)
const _hoisted_12 = { class: "form-floating mb-2" }
const _hoisted_13 = ["type"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "floatingPassword" }, "Contraseña", -1)
const _hoisted_15 = {
  key: 0,
  class: "bi bi-eye"
}
const _hoisted_16 = {
  key: 1,
  class: "bi bi-eye-slash"
}
const _hoisted_17 = { class: "small text-end" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary mt-4",
  type: "submit"
}, "Acceder", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  href: "register",
  class: "w-100 btn btn-lg btn-outline-primary"
}, "Regístrate", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBarNew = _resolveComponent("NavBarNew")!
  const _component_loading = _resolveComponent("loading")!
  const _component_alert = _resolveComponent("alert")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_form_code_msg = _resolveComponent("form-code-msg")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_NavBarNew, { hiddenOption: false }),
    _createVNode(_component_loading, {
      loading: $setup.data_.loading
    }, null, 8, ["loading"]),
    _createVNode(_component_alert, {
      onOnFire: $setup.eventCloseAlert,
      data_alert: $setup.data_alert
    }, null, 8, ["onOnFire", "data_alert"]),
    _createElementVNode("header", _hoisted_2, [
      ($setup.data_.code_temp === '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _hoisted_9,
                    _createElementVNode("form", {
                      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"])),
                      class: "mb-2",
                      autocomplete: "off"
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.cif) = $event)),
                          type: "text",
                          class: "form-control",
                          id: "floatingInput",
                          placeholder: "NIF/CIF",
                          required: ""
                        }, null, 512), [
                          [_vModelText, $setup.data.cif]
                        ]),
                        _hoisted_11
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.password) = $event)),
                          type: $setup.form_.showPass ? 'text' : 'password',
                          class: "form-control",
                          id: "floatingPassword",
                          placeholder: "Contraseña",
                          required: ""
                        }, null, 8, _hoisted_13), [
                          [_vModelDynamic, $setup.data.password]
                        ]),
                        _hoisted_14,
                        _createElementVNode("div", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showPass())),
                          class: "view-pass"
                        }, [
                          (!$setup.form_.showPass)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                            : _createCommentVNode("", true),
                          ($setup.form_.showPass)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_17, [
                        _createVNode(_component_router_link, { to: "recovery" }, {
                          default: _withCtx(() => [
                            _createTextVNode("¿Olvidaste tu contraseña?")
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_18
                    ], 32),
                    _hoisted_19
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.data_.code_temp !== '' )
        ? (_openBlock(), _createBlock(_component_form_code_msg, {
            key: 1,
            onOnFire: $setup.getToken,
            onOnFireCode: _cache[4] || (_cache[4] = ($event: any) => ($setup.submit())),
            code_: $setup.data_.code_temp,
            "onUpdate:code_": _cache[5] || (_cache[5] = ($event: any) => (($setup.data_.code_temp) = $event)),
            id: $setup.data_login.userId
          }, null, 8, ["onOnFire", "code_", "id"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Footer)
  ], 64))
}